import React, { useState } from "react";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import {
  registerUserAsSuperAdmin,
  validateRegistrationLinkForSuper,
} from "../../api/registration";
import SuperAdminRegForm from "../../components/forms/SuperAdminRegForm";
import { auth } from "../../firebase";

const SuperAdminSecretRegistration = () => {
  const initialVals = {
    email: "",
    role: "super-admin",
  };
  const { token } = useParams();
  const dispatch = useDispatch();
  const history = useHistory();
  const [loading, setLoading] = useState(true);
  const [values, setValues] = useState(initialVals);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [sameEmail, setSameEmail] = useState(true);
  const [password, setPassword] = useState("password");

  useEffect(() => {
    validateRegistrationLinkForSuper(token)
      .then((res) => {
        setEmail(res.data);
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
        toast.error(
          error.response
            ? error.response.data
            : "Some error occured please try again later"
        );
        history.push("/");
      });
  }, [token]);

  const handleChange = (e) => {
    e.preventDefault();
    setValues({ ...values, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      if (sameEmail) values.email = email;
      const resultingUser = await auth.createUserWithEmailAndPassword(
        email,
        password
      );
      const idTokenResult = await resultingUser.user.getIdTokenResult();
      const res = await registerUserAsSuperAdmin(values, name, token);
      setLoading(false);
      setValues(initialVals);
      toast.success(res.data);
      dispatch({
        type: "LOGGED_IN_USER",
        payload: {
          name: res.data.name,
          email: res.data.email,
          token: idTokenResult.token,
          _id: res.data._id,
        },
      });
      history.push("/");
    } catch (error) {
      setLoading(false);
      if (error.response) toast.error(error.response.data);
      else if (error.message) toast.error(error.message);
      else toast.error("Some error occured please try again later");
      console.log(error);
    }
  };

  return (
    <div style={{ padding: "5vh 30vw" }} className="registration-div">
      {loading ? (
        <h1>...loading</h1>
      ) : (
        <>
          <h4 style={{ textAlign: "center" }}>
            Please Fill The Registration Form
          </h4>
          <SuperAdminRegForm
            handleChange={handleChange}
            handleSubmit={handleSubmit}
            values={values}
            setName={setName}
            name={name}
            sameEmail={sameEmail}
            setSameEmail={setSameEmail}
            email={email}
            setPassword={setPassword}
            password={password}
          />
        </>
      )}
    </div>
  );
};

export default SuperAdminSecretRegistration;
